<template>
	<a-modal title="Select Template" :visible="visible" @cancel="handleCancel" :footer="null" width="60%">
		<div class="mb-3">
			<div class="row">
				<div class="col-md-4">
					<input type="text" class="form-control" v-model="filter.search" placeholder="Search..." @input="onSearch" />
				</div>
			</div>
		</div>

		<Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe
			@change="handleTableChange" rowKey="template_id">
		 	<template slot-scope="{ row }" slot="action">
				<button class="btn btn-primary btn-sm" @click="selectTemplate(row)">
					{{ $t('purchaseRequest.select') }}
				</button>
			</template>
		</Table>
	</a-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	name: 'TemplateModal',
	data() {
		return {
			visible: false,
			loading: false,
			resources: [],
			filter: {
				search: ''
			},
		}
	},
	computed: {
		columns() {
      return [
        {
          title: this.$t('purchaseRequest.templateName'),
          key: 'template_name',
          minWidth: 130,
          sortable: true
        },        
				{
          title: this.$t('purchaseRequest.description'),
          key: 'template_description',
          minWidth: 130,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 130
        }
      ]
    }
	},
	methods: {
		...mapActions('purchaseRequest/purchaseRequest', ['getTemplate']),
		show() {
			this.visible = true
			this.fetchTemplates()
		},
		handleCancel() {
			this.visible = false
		},
		async fetchTemplates() {
			this.loading = true
			try {
				const response = await this.getTemplate({
					filter: {
						search: this.filter.search
					}
				})
				this.resources = response.data
			} catch (error) {
				this.$toasted.error(error.message || 'Failed to fetch templates')
			} finally {
				this.loading = false
			}
		},
		handleTableChange(pagination) {
			this.pagination.current = pagination.current
			this.pagination.pageSize = pagination.pageSize
			this.fetchTemplates()
		},
		onSearch() {
			this.fetchTemplates()
		},
		selectTemplate(template) {
			this.$emit('select', template)
			this.visible = false
		}
	}
}
</script>
